import { Link } from "shared/components/Link";
import { AppRoute } from "../../constants";
import Layout from "../../components/mainPage/Layout";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    Приложение для нескольких мониторов/видеостен (Multimonitor Desktop)
                </h1>

                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        SCADA NPT Expert Multimonitor Desktop представляет собой расширенную версию <Link className="text-links" to={`/${AppRoute.DesktopApplication}`}>SCADA NPT Expert Desktop</Link>.
                    </p>
                    <p>
                        В версии Multimonitor SCADA NPT Expert Desktop поддерживается вывод информации на видеокуб, видеостену или на несколько объединенных экранов (4 и более).
                    </p>

                    <p>
                        Мультимониторный клиент SCADA используется для решения задач, где требуется одновременное отображение большого объема информации на нескольких экранах. Это особенно полезно в сложных промышленных системах, где операторам необходимо контролировать множество параметров и процессов. Основные задачи, для которых применяется мультимониторный клиент SCADA:
                    </p>

                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li">Расширенная визуализация процессов
                            <ul>
                                <li className=" ">Отображение различных аспектов технологического процесса на отдельных экранах (например, один экран для графиков, другой для схем оборудования, третий для аварийных сигналов).</li>
                                <li className=" ">Удобство мониторинга крупных систем, таких как энергосети, нефтеперерабатывающие заводы или водоканалы.</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">Повышение эффективности работы операторов
                            <ul>
                                <li className=" ">Распределение информации между несколькими экранами для снижения нагрузки на оператора.</li>
                                <li className=" ">Возможность одновременного отслеживания критических параметров и управления оборудованием.</li>
                            </ul>
                        </li>


                        <li className="mb-1 description__number-li">Мониторинг крупномасштабных систем
                            <ul>
                                <li className=" ">Контроль распределенных объектов (например, трубопроводов, электросетей или транспортных систем) с отображением данных на разных экранах.</li>
                                <li className=" ">Визуализация географически распределенных данных на картах.</li>
                            </ul>
                        </li>


                        <li className="mb-1 description__number-li">Анализ данных и отчетность
                            <ul>
                                <li className=" ">Отображение исторических данных, трендов и аналитических отчетов на отдельных экранах.</li>
                                <li className=" ">Сравнение текущих и исторических данных для анализа эффективности процессов.</li>
                            </ul>
                        </li>


                        <li className="mb-1 description__number-li">Управление аварийными ситуациями
                            <ul>
                                <li className=" ">Выделение одного экрана для отображения аварийных сигналов и предупреждений.</li>
                                <li className=" ">Быстрое реагирование на нештатные ситуации благодаря четкому разделению информации.</li>
                            </ul>
                        </li>


                        <li className="mb-1 description__number-li">Обучение и симуляция
                            <ul>
                                <li className=" ">Использование нескольких экранов для обучения операторов, где один экран отображает реальные данные, а другой — учебные материалы или симуляции.</li>
                            </ul>
                        </li>



                        <li className="mb-1 description__number-li">Оптимизация рабочего пространства
                            <ul>
                                <li className=" ">Организация рабочего места оператора с разделением задач между экранами (например, один экран для управления, другой для мониторинга, третий для отчетов).</li>
                                <li className="">Удобство работы в диспетчерских центрах и контрольных комнатах.</li>
                            </ul>
                        </li>



                        <li className="mb-1 description__number-li">Масштабируемость системы
                            <ul>
                                <li className=" ">Возможность добавления новых экранов при расширении системы или увеличении количества контролируемых параметров.</li>
                                <li className=" ">Гибкость в настройке интерфейсов под конкретные задачи.</li>
                            </ul>
                        </li>


                    </ul>
                    <p>
                        <b>Примеры применения</b>
                    </p>

                    <div><b>Энергетика:</b>  Мониторинг энергосетей, отображение данных с подстанций, генераторов и распределительных узлов.</div>
                    <div><b>Нефтегазовая промышленность:</b>  Контроль добычи, транспортировки и переработки углеводородов.</div>
                    <div><b>Водоснабжение и канализация:</b>  Управление насосными станциями, резервуарами и очистными сооружениями.</div>
                    <div><b>Транспорт:</b>  Управление светофорами, мониторинг движения и контроль инфраструктуры.</div>


                </div>

            </div>
        </div>
    </Layout>
}

export const meta = {
    title: 'Приложение для нескольких мониторов/видеостен (Multimonitor Desktop)',
    description: 'SCADA NPT Expert Multimonitor Desktop представляет собой расширенную версию SCADA NPT Expert Desktop.'
}